var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"risk-score-tag",class:'risk-level-' + _vm.level,attrs:{"role":"status","aria-label":'风险等级：' + _vm.label}},[_c('span',{staticClass:"score-num"},[_vm._v(_vm._s(_vm.score))]),(_vm.showLabel)?_c('span',{staticClass:"score-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }